import $ from "jquery";
import AppBase from "../AppBase";


export default class NavigationApp extends AppBase {
  constructor() {
    super();
  }

  init() {
    super.init();

    NavigationApp.BREAK_POINT = 768;

    this.currentId = "image--0";
    this.$image = $("#js-menuContentsImage");

    const $menuContents = $("#js-menuContents");
    const $stage = $("#js-stage");
    const isBlack = $stage.hasClass("black");
    const $buttons = $("#js-menuContents").find(".js-button");

    $buttons.each((i, el) => {
      $(el).on("mouseenter", (e) => {
        if ($(window).width() < NavigationApp.BREAK_POINT) {
          return;
        }

        const $button = $(e.target).closest(".js-button");
        const id = $button.data("id");
        this.setImage(id);
      });

      $(el).on("mouseleave", () => {
        if ($(window).width() < NavigationApp.BREAK_POINT) {
          return;
        }

        const id = "0";
        this.setImage(id);
      });
    });

    $("#js-sp-calendarButton").click(() => {
      $menuContents.fadeOut(200);
      $("#menuToggle").prop("checked", false);
      $("html").css({"overflow-y": "auto"});
    });

    $("#menuToggle").change((e) => {
      const checked = $(e.target).prop("checked");

      if (checked) {
        $menuContents.fadeIn(400);
        // $stage.addClass("black");
        $("html").css({"overflow-y": "hidden"});
      } else {
        $menuContents.fadeOut(200);
        $("html").css({"overflow-y": "auto"});

        if (!isBlack) {
          // $stage.removeClass("black");
        }
      }
    });
  }

  setImage(id) {
    this.$image.stop();
    this.$image.fadeOut(300, () => {
      this.$image.removeClass(`image--${this.currentId}`);
      this.$image.addClass(`image--${id}`);
      this.currentId = id;
      this.$image.fadeIn(300);
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/apps/modules/NavigationApp.js